import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../state.js';

const LABEL: Record<string, string> = {
  idle: 'Tudo sincronizado',
  syncing: 'Sincronizando…',
  offline: 'Sem internet',
  error: 'Falha ao sincronizar',
  unauthenticated: 'Sessão expirada',
};

export function SyncBadge(): JSX.Element {
  const { state, pending, lastAt } = useApp((s) => s.sync);
  const tone = state === 'idle' ? 'ok' : state === 'offline' ? 'warn' : state === 'syncing' ? '' : 'danger';
  const ago = lastAt ? `· há ${Math.max(0, Math.round((Date.now() - lastAt) / 60000))} min` : '';
  return (
    <span className={`badge ${tone}`} title={pending ? `${pending} alterações na fila` : undefined}>
      {LABEL[state] ?? state}{pending ? ` · ${pending} na fila` : ` ${ago}`}
    </span>
  );
}

export default function TopBar({ title, back, children }: { title: ReactNode; back?: string; children?: ReactNode }): JSX.Element {
  const navigate = useNavigate();
  return (
    <div className="topbar">
      {back !== undefined ? (
        <button className="ghost" onClick={() => navigate(back)} aria-label="Voltar">←</button>
      ) : null}
      <strong className="grow">{title}</strong>
      {children}
    </div>
  );
}
